import "./App.css";
import { Navbar } from "./components/Navbar/Navbar";
import Hero from "./sections/Hero/Hero";
import Story from "./sections/Story/Story";
import Services from "./sections/Services/Services";
import Team from "./sections/Team/Team";
import Gallery from "./sections/Gallery/Gallery";
import { useEffect } from "react";
import { NavbarMobile } from "./components/NavbarMobile/NavbarMobile";
import Contact from "./sections/Contact/Contact";
import Footer from "./sections/Footer/Footer";

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="firstSection">
      <Navbar />
      <NavbarMobile />
      <Hero />
      <Story />
      <Gallery />
      <Services />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
